import React, { useState } from "react"
import dayjs from "dayjs"
import { useQuery } from "@apollo/client"
import GET_INCOMING_STOCK from "../../../graphql/queries/incomingStock/GetIncomingStock"
import { IncomingStock } from "lib/types/generated/graphql-types"
import { IncomingWrapper } from "../Shared.styled"

type Props = {
  productVariantId: string
}

const IncomingStockRow = ({productVariantId} : Props) => {
  const [incomingStock, setIncomingStock] = useState<IncomingStock[]>([])

  const { loading, error } = useQuery(GET_INCOMING_STOCK, {
    variables: {productVariantId},
    onCompleted: (data) => setIncomingStock(data?.getIncomingStock),
    fetchPolicy: "network-only"
  })

  const recentStockDataList = incomingStock
    ?.filter((stock) => !!stock.incomingStockDate)
    ?.filter((stock) => dayjs(stock.incomingStockDate).isAfter(dayjs()))
    ?.sort((a, b) => dayjs(a.incomingStockDate).valueOf() - dayjs(b.incomingStockDate).valueOf())

  const recentStock = recentStockDataList.length > 0 ? recentStockDataList[0] : undefined

  if (loading)
    return (
      <IncomingWrapper className={"blur"}>
        <div>
          <b>Incoming quantity:</b> 0
        </div>
        <div>
          <b>Incoming date:</b> 2000-00-00
        </div>
      </IncomingWrapper>
    )

  if (error || !recentStock) return null

  return (
    <IncomingWrapper>
      <div>
        <b>Incoming quantity:</b> {recentStock?.incomingStockQuantity}
      </div>
      <div>
        <b>Incoming date:</b> {recentStock?.incomingStockDate}
      </div>
    </IncomingWrapper>
  )
}

export default IncomingStockRow
